import { Currency, PayoutCurrency } from 'src/types/listing';

/**
 * The stablecoin a listing's price is quoted in on the shop window.
 *
 * The token is pegged to the listing's currency, so the price *is* the amount — no exchange rate
 * takes part (settlement-amount spec §2, multichain spec §2). A euro car is €18,400 and 18,400
 * EURC, never 21,149 USDT at yesterday's rate.
 *
 * One token per currency (one-rail spec §0, Tim's decision of 2026-10-20): USD settles in USDC,
 * EUR in EURC, both on Base. The answer is read off the currency alone, never off the listing's
 * `payoutCurrency`: that field was the dealer's pick until the api began deriving it (api#403),
 * and a dollar car saved before then may still carry USDT — a token no new purchase settles in.
 */
export const settlementToken = (currency: Currency | undefined): PayoutCurrency | undefined => {
  if (currency === Currency.EUR) {
    return PayoutCurrency.EURC;
  }

  if (currency === Currency.USD) {
    return PayoutCurrency.USDC;
  }

  return undefined;
};
